import React from "react";
import styled from "@emotion/styled";

import productsData from "./data";
import Product from "./Product";

function ProductList() {
  return (
    <ListStyled>
      {productsData.map((product, i) => (
        <Product key={i} right={i === 1} {...product} />
      ))}
    </ListStyled>
  );
}

const ListStyled = styled.section`
  width: 100%;
  margin: 50px 0;

  @media (max-width: 500px) {
    margin: 25px 0;
  }
`;

export default ProductList;
